// reducers/systems/index.js

import { combineReducers }   from 'redux';
import { catalog }           from './catalog';
import { catalogHasErrored } from './catalog';
import { catalogIsLoading }  from './catalog';
import { inputs }            from './inputs';
import { inputsHasErrored }  from './inputs';
import { inputsIsLoading }   from './inputs';
import { execute }           from './execute';
import { executeHasErrored } from './execute';
import { executeIsLoading }  from './execute';

const catalogReducers = combineReducers({
  catalog,
  catalogHasErrored,
  catalogIsLoading
});

const inputsReducers = combineReducers({
  inputs,
  inputsHasErrored,
  inputsIsLoading
});

const executeReducers = combineReducers({
  execute,
  executeHasErrored,
  executeIsLoading
});

export default combineReducers({
  catalog: catalogReducers,
  inputs: inputsReducers,
  execute: executeReducers
});